import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import api from '../api/axios';
import { useAuth } from '../context/AuthContext';

const Verify = () => {
  const navigate = useNavigate();
  const [status, setStatus] = useState('Verifying...');
  const { logout, isLogin } = useAuth();

  useEffect(() => {
    if (isLogin) {
      logout();
    }
    const urlParams = new URLSearchParams(window.location.search);
    const token = urlParams.get('token'); // ✅ GET token from URL (NOT localStorage)
    console.log(token);
    if (!token) {
      setStatus('Invalid verification link.');
      return;
    }

    axios
      .get(`${api}/auth/verify?token=${token}`)
      .then((res) => {
        setStatus('✅ Email verified successfully! Redirecting...');
        console.log(res);
        if (res.data?.verified === true) {
          // ✅ check if verified true from backend
          localStorage.setItem('token', res.data.token);
          navigate('/signup'); // ✅ if verified then directly redirect
        } else {
          setStatus('❌ Verification failed.');
        }
      })
      .catch((err) => {
        setStatus('❌ Verification failed or link expired.');
        console.log(err);
      });
  }, [navigate, isLogin]);

  return (
    <div className="verify-page">
      <h1>{status}</h1>
    </div>
  );
};

export default Verify;
